export default {
  /*settlement: {
    base64: '',
    pagoPlanilla: false,
    asesorPaga: false,
    koaPaga: false,
    retefuente: null,
    user: null,
    password: null,
    operadora: null,
    aceptaLiquidacion: null,
    controlSalario: false
},*/
}
